export const PageList = {
  PROGRESSIVE_PLAN: '/sales/home/progressiveplan.html',
  STREAMLINE_ORDER: '/sales/home/streamlineordering.html',
  ADDONS: '/sales/home/addons.html',
  SETUP: '/sales/home/setup.html',
  CART: '/sales/home/cart.html',
  EXPRESS_CHECKOUT: '/sales/home/expresscheckout.html',
  CONTACT_INFO: '/sales/home/contactinfo.html',
  CREATE_PROFILE: '/sales/home/createprofile.html',
  SHIPPING_INFO: '/sales/home/shipping.html',
  CREDIT_CHECK: '/sales/home/creditcheck.html',
  PAYMENT: '/sales/home/payment.html',
  ORDER_REVIEW: '/sales/home/orderreview.html',
  APPOINTMENT: '/sales/home/appointment.html',
  BROADBAND_FACTS: '/sales/home/broadBandFacts.html',
  DEVICE_UPGRADE: '/sales/home/DeviceUpgrade.html',
  ADDRESS_SEARCH: '/sales/home/addressSearch.html',
  EXPRESS_CART: '/sales/home/expresscart.html?expresscart=true&addplan=false',
  CART_ACCOUNT_FAIL: '/sales/home/expresscart.html?ACCFail=Y',
  CART_COLLECTIONS: '/sales/home/expresscart.html?collections_IND=Y',
  CART_CASH_ONLY: '/sales/home/expresscart.html?cashonly=Y',
  CART_FRAUD_ORDER: '/sales/home/expresscart.html?fraudorder=Y',
  NEXTGEN_EXPRESS_CART: '/sales/home/expresscart.html',
  FIVEG_HOME: '/5g/home/',
  PAY_BALANCE: '/digital/nsa/secure/ui/payment/paybill/',
};
